import React, { useState, useRef, useEffect } from "react";
import { EmailChips } from "../components/Components";
import { FileBubble } from "../components/Components";
import { useHistory } from "react-router-dom";
import { sendEmail } from "../service/blackbox-service";

const EmailForm = ({ cancelFormEvent }) => {
  let history = useHistory();
  const [activeChat, setActiveChat] = useState("");
  const [files, setFiles] = useState([]);

  const fileAttachment = useRef();
  const subject = useRef("");
  const body = useRef("");
  const [emailItems, setEmailItems] = useState([]);
  const [emailCCItems, setEmailCCItems] = useState([]);
  const [emailBCCItems, setEmailBCCItems] = useState([]);
  const [isValid, setIsValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errormsg, setErrorMsg] = useState("")

  useEffect(() => {
    const channels = history.location.state.channels;
    setActiveChat(channels[0].header);
  }, [history.location.state]);

  const handleFileChange = (event) => {
    validateSingleFile(event)
  
  };

  async function validateSingleFile(event) {
    
    let tempFiles = [...files]
    if(event.target.files.length === 1){
      let singleSizeFile = validateFile(event.target.files[0])
      if(singleSizeFile <= 3.5) {
        let size = validateFileTotal(files,event.target.files[0])
        if (size > 3.5) {
            setErrorMsg("Once or more files not attached. Total attachment limit is 3.5 MB")
        }else {
          tempFiles = [...tempFiles, event.target.files[0]];
          setErrorMsg("")
        }
      } else {
        setErrorMsg(`The file/s you are trying to send exceed the 3.5 MB total attachment limit.`)
      }
    }  else {
      Array.prototype.forEach.call(event.target.files, function(item) {
        if(item.size/1024/1024 <= 3.5) {
              let size = validateFileTotal(tempFiles, item)
              if (size > 3.5) {
                setErrorMsg("Once or more files not attached. Total attachment limit is 3.5 MB")
              }else {
                let fileChecker = validateTotalWithNewArrayFile(event.target.files)
                tempFiles = [...tempFiles, item];
                  if(fileChecker >= 3.5) {
                    setErrorMsg("Once or more files not attached. Total attachment limit is 3.5 MB")
                  } else {
                    setErrorMsg("")
                  }
              }
            }else {
              setErrorMsg("Once or more files not attached. Total attachment limit is 3.5 MB")
            }
      })
    }
    await setFiles([...tempFiles]);
   
  }

  function validateMultipleFile(filesData) {
    let data = [...filesData]
    const isBelowThreshold = (currentSize) => currentSize.size/1024/1024 < 3.5;
    return data.every(isBelowThreshold)
  }
  
  function validateFileTotal(files, item?) {
    let newFiles
    if(item) {
       newFiles= [...files, item]
    } else {
      newFiles= [...files]
    }
    
    if(files.length !== 0) {
      let size = newFiles.reduce((a , b) => a + b.size, 0)
      return size/1024/1024;
    }
  }

 function validateTotalWithNewArrayFile(items) {
    let newArray = [...files]
    if(items.length > 1) {
      for(const item of items) {
        newArray = [...newArray,item]
      }
    }

    return validateFileTotal(newArray)
  }

  function validateFile(item) {
    return item.size/1024/1024;
  }

  const deleteFile = (index) => {
    const tempFiles = [...files];
    tempFiles.splice(index, 1);
    setFiles([...tempFiles]);
    setErrorMsg("")
  };

  useEffect(() => {
    messageBlur();
  }, [emailItems]);

  const messageBlur = () => {
    const bodyVal = body.current.value;

    const checkData = (data) => {
      if (Object.keys(data).length === 0) {
        return false;
      }
      return true;
    };

    if (checkData(bodyVal) && emailItems.length > 0) {
      setIsValid(true);
    } else {
      setIsValid(false);
    }
  };

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const getAttachments = async () => {
    let finalAttachments = [];
    if (files.length > 0) {
      let tempAttachments = await new Promise(async (resolve, reject) => {
        let tempArr = [];
        for await (const element of files) {
          const base = await toBase64(element);

          let fileType = base
            .split(",")[0]
            .replace("data:", "")
            .replace("base64", "")
            .replace(";", "");

          let file = element.name.split(".");

          tempArr.push({
            content: base.split(",")[1],
            filename: element.name,
            type: file[1],
            fileType,
          });
        }

        resolve(tempArr);
      });

      finalAttachments = tempAttachments;

      return finalAttachments;
    }

    return;
  };

  const sendEmailEvent = async () => {
    const finalAttachments = await getAttachments();
    const activeChatHeads = [...history.location.state.channels].filter(
      (data) => data.isActive === true
    );
    const chatHeadType = activeChatHeads[0].information.chatHeads;
    let collectHead;
    let channelHead = activeChatHeads[0].channel;
    if (chatHeadType === "All") {
      if (history.location.state.tripId) {
        collectHead = history.location.state.topic;
      } else {
        collectHead = history.location.state.reservationId;
      }
      const Allpayload = {
        topic: collectHead,
        channel: channelHead,
        type: "EMAIL",
        conversation: {
          userId: history.location.state.userId, //userID
          fullName: history.location.state.fullName, // fullanme
          userName: history.location.state.userName,
          to: emailItems,
          cc: emailCCItems ? emailCCItems : [],
          bcc: emailBCCItems ? emailBCCItems : [],
          subject: subject.current.value || "",
          text: body.current.value || "",
          attachments: finalAttachments ? finalAttachments : [],
        },
        senderInfo: {
          memberId: history.location.state.memberId,
          name: history.location.state.companyName,
        },
      };
      setIsLoading(true);
      let result =  await sendEmail(Allpayload);

      if (result.status === 200) {
        setIsLoading(false);
        if (finalAttachments?.length) {
          setFiles([]);
        }
        subject.current.value = "";
        body.current.value = "";
        messageBlur();
      } else {
        setIsLoading(false);
        messageBlur();
      }
    } else {
      collectHead = history.location.state.topic;
    
      const payload = {
        topic: history.location.state.topic,
        channel: channelHead,
        type: "EMAIL",
        conversation: {
          userId: history.location.state.userId, //userID
          fullName: history.location.state.fullName, // fullanme
          userName: history.location.state.userName,
          to: emailItems,
          cc: emailCCItems ? emailCCItems : [],
          bcc: emailBCCItems ? emailBCCItems : [],
          subject: subject.current.value || "",
          text: body.current.value || "",
          attachments: finalAttachments ? finalAttachments : [],
        },
        senderInfo: {
          memberId: history.location.state.memberId,
          name: history.location.state.companyName,
        },
      };

      setIsLoading(true);

      let result = await sendEmail(payload);

      if (result.status === 200) {
        setIsLoading(false);
        if (finalAttachments?.length) {
          setFiles([]);
        }
        subject.current.value = "";
        body.current.value = "";
        messageBlur();
      } else {
        setIsLoading(false);
        messageBlur();
      }
    }
  };

  return (
    <div className="bg-gray-100 border-t p-4 flex flex-col gap-4">
      {!isLoading ? (
        <>
          <EmailChips
            setEmailItems={setEmailItems}
            setEmailCCItems={setEmailCCItems}
            setEmailBCCItems={setEmailBCCItems}
            placeholder="To:"
          />
          <input
            className="bg-white rounded-md w-full py-2 pr-4 pl-2 text-black leading-tight focus:outline-none resize-none border"
            type="text"
            name="subject"
            placeholder="Subject:"
            ref={subject}
            onChange={() => messageBlur()}
            disabled={isLoading}
          />
          <textarea
            className="bg-white rounded-md w-full py-2 pr-4 pl-2 text-black leading-tight focus:outline-none resize-none border"
            type="text"
            name="body"
            placeholder="Type message here..."
            ref={body}
            onChange={() => messageBlur()}
            disabled={isLoading}
          />
          <div className=" bg-gray-100 px-4 flex flex-row gap-4 overflow-y-hidden items-center">
            {files.length !== 0 &&
              files.map((file, index) => (
                <FileBubble
                  key={index}
                  fileName={file.name}
                  deleteFile={deleteFile}
                  index={index}
                />
              ))}
          </div>
          <div className="flex flex-row justify-between items-center">
            <button
              className="flex flex-col justify-center items-center h-9 w-10 rounded-md bg-gray-200 border border-gray-300"
              onClick={() => {
                fileAttachment.current.click();
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12.576"
                height="24.395"
                viewBox="0 0 12.576 24.395"
                fill="currentColor"
              >
                <path
                  id="Icon_ionic-ios-attach"
                  data-name="Icon ionic-ios-attach"
                  d="M21.6,9.278a.85.85,0,0,0-.849.849V20.711a4.39,4.39,0,0,1-1.2,3A4.309,4.309,0,0,1,16.535,25h-.74a4.231,4.231,0,0,1-2.983-1.339,4.371,4.371,0,0,1-1.3-3.005V7a2.959,2.959,0,0,1,.942-2.15,3.239,3.239,0,0,1,2.232-.887A3.03,3.03,0,0,1,17.744,7v12.75a1.721,1.721,0,0,1-1.579,1.753,1.673,1.673,0,0,1-1.535-1.753V12.479a.849.849,0,1,0-1.7,0v7.273A3.266,3.266,0,0,0,18.49,22.2a3.439,3.439,0,0,0,.953-2.45V7A4.758,4.758,0,0,0,14.668,2.25a4.777,4.777,0,0,0-3.386,1.388,4.7,4.7,0,0,0-1.41,3.37V20.662a6.084,6.084,0,0,0,1.775,4.246,5.885,5.885,0,0,0,4.143,1.737h.74A5.947,5.947,0,0,0,20.662,24.9a6.116,6.116,0,0,0,1.3-1.884,5.7,5.7,0,0,0,.485-2.292V10.128A.842.842,0,0,0,21.6,9.278Z"
                  transform="translate(-9.872 -2.25)"
                />
              </svg>

              <input
                type="file"
                ref={fileAttachment}
                onChange={handleFileChange}
                className="hidden"
                multiple
              />
            </button>

            <div className="flex flex-row gap-2">
              <button
                onClick={() => cancelFormEvent(0)}
                className="h-9 w-20 rounded-md py-1 bg-active border text-white"
              >
                Cancel
              </button>
              <button
                className={`${
                  isValid ? "bg-active" : "bg-gray-300"
                } h-9 w-20 rounded-md py-1 border text-white`}
                onClick={() => sendEmailEvent()}
                disabled={isValid ? false : true}
              >
                Send
              </button>
            </div>
          </div>

          <div className=" text-red-400 pt-1 text-sm">
            {errormsg}
          </div>
        </>
      ) : (
        <div className="flex flex-col justify-center items-center h-160">
          <svg
            role="status"
            className="inline w-22 h-16 mr-2 text-gray-200 animate-spin dark:text-gray-600 "
            viewBox="0 0 100 101"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
              fill="currentColor"
            />
            <path
              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
              fill="#243c5a"
            />
          </svg>
        </div>
      )}
    </div>
  );
};

export default EmailForm;
